<template>
  <van-popup
    v-model:show="visible"
    :close-on-click-overlay="closeOnClickOverlay"
    teleport="body"
    @close="handlePopupClosed"
  >
    <div class="popup-view" :style="popupStyle">
      <div v-if="title && title !== null" class="popup-view__header">
        <p class="popup-view__header__title">{{ title }}</p>
      </div>
      <slot v-else name="header"></slot>
      <slot name="content"></slot>
    </div>

    <div v-if="closeable" class="close-container chxy-row-c-c" @click="close">
      <van-icon name="close" size="32" color="#FFFFFF" />
    </div>
  </van-popup>
</template>

<script setup>
const visible = ref(false)

const props = defineProps({
  title: { type: String, default: '' },
  closeable: { type: Boolean, default: true },
  closeOnClickOverlay: { type: Boolean, default: false },
  padding: { type: [Number, String], default: 10 },
  radius: { type: [Number, String], default: 15 },
  background: { type: String, default: '#A4D5F5' },
  borderColor: { type: String, default: 'transparent' },
})

const popupStyle = computed(() => {
  return {
    padding: !isNaN(props.padding) ? `${props.padding}px` : props.padding,
    'background-color': props.background,
    'border-color': props.borderColor,
    'border-radius': `${props.radius}px`,
  }
})

const emit = defineEmits(['close'])

const open = () => {
  visible.value = true
}

/** 仅关闭弹窗；由 van-popup @close 统一向上 emit，避免重复触发 */
const close = () => {
  if (!visible.value) return
  visible.value = false
}

/** van-popup 真正关闭后回调（只触发一次） */
const handlePopupClosed = () => {
  emit('close')
}

defineExpose({ open, close })
</script>

<style scoped lang="less">
:deep(.van-overlay) {
  background-color: rgba(0, 0, 0, 0.3) !important;
}
.popup-view {
  position: relative;
  width: 100%;
  border: 1px solid var(--popup-primary-border);
  overflow-y: visible;

  &__header {
    width: 100%;
    height: 24px;
    font-size: 16px;
    text-align: center;
    color: #ffffff;
    line-height: 24px;
  }
}
</style>
